import {
  FilterType,
  buildTrainingSessionsByEmployeeDataTableFilter,
  useTrainingSessionsByEmployeeDataTable,
} from 'generated/resources/datatable.graphql'
import { TrainingsSessionAttendanceStatusEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { SessionMembershipStatusTag } from '../../../SessionMembershipStatusTag'

type FilterOption = {
  label: string
  value: TrainingsSessionAttendanceStatusEnum
  component: JSX.Element
}

export const attendanceFilter = (
  source: ReturnType<typeof useTrainingSessionsByEmployeeDataTable>
) => {
  const options: FilterOption[] = [
    {
      label: i18n.t('trainings.session_access_membership_table.not_started'),
      value: 'pending',
      component: <SessionMembershipStatusTag status="pending" />,
    },
    {
      label: i18n.t('trainings.session_access_membership_table.started'),
      value: 'inprogress',
      component: <SessionMembershipStatusTag status="inprogress" />,
    },

    {
      label: i18n.t('trainings.session_access_membership_table.completed'),
      value: 'completed',
      component: <SessionMembershipStatusTag status="completed" />,
    },
    {
      label: i18n.t('trainings.session_access_membership_table.absent'),
      value: 'missing',
      component: <SessionMembershipStatusTag status="missing" />,
    },
  ]

  return buildTrainingSessionsByEmployeeDataTableFilter(source, {
    identifier: 'status_filter',
    title: i18n.t('trainings.trainings_revamp.event_sidepanel.filters.attendance_status'),
    path: 'sessionAttendancesStatus',
    default: true,
    type: FilterType.String,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options,
      },
    ],
  })
}
